module.exports = __webpack_public_path__ + "media/images/main/k3-374cff9cb86ee5d70cc39bcfee5ee559.jpg";